import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Input,
  Select,
  Tooltip,
  Button,
  Form,
  Col,
  Row,
  DatePicker,
  Table,
  Radio,
  Tag,
  Tabs,
  Typography,
  Modal,
  Checkbox,
  Icon,
  message,
  editData,
  Popconfirm,
  Upload,
} from "antd";
import { Link, useHistory, useLocation, withRouter } from "react-router-dom";
import { LeftOutlined, UploadOutlined } from "@ant-design/icons";
const { Group } = Radio;
import moment from "moment";
// import { Table, Tag, Space } from 'antd';
import { platformApi } from "../../../../api";
import { useBranch } from "../../../../ContextAPI/branch";
import { ContextAPI } from "../../../../ContextAPI";
import ColorSelection from "../ColorSelection";
import { getUUID } from "../../../../_helpers/utils";
// import AddCustomer from "./AddCustomer/";
import WrappedCustomerAddModal from "../../JobOrder/JobOrderModal/VehicleDetails/AddCustomer"
import WrappedVehicleForm from "../../Vehicles/VehicleForm";
// ----------------------
import { GST18, GST28, GST12, GST5 } from "../../../../utils";
import { formatVehicleName } from "../../../../utils/vehicleDisplayName";
import VehicleName from "../../../VehicleName";
import "./index.less";

// -----------------

const { Title, Text } = Typography;
const { Option } = Select;
const { Item } = Form;
const { TabPane } = Tabs;


const formatPhones = (contacts) =>
  (contacts || []).map((c) => c?.phone).filter(Boolean).join(" / ");

const formatCustomerLabel = (name, contacts) =>
  `${name || ""} - ${formatPhones(contacts)}`;

const Index = ({ form }) => {
  const {
    getFieldDecorator,
    setFieldsValue,
    getFieldValue,
    validateFields,
  } = form;

  const partItemData = {
    id: getUUID(),
    partNumber: {},
    quantity: 0,
    unitRate: "",
    grossAmount: "",
    grandTotal: 0,
    hsn: {},
    discount: "",
    rate: "",
    igst: 0,
    cgst: 0,
    sgst: 0,
    gstRate: 0,
    igstAmount: 0,
    cgstAmount: 0,
    sgstAmount: 0,
    discountAmount: 0,
    discountPercent: 0,
    remove: "",
  };

  const { selectBranch, nearestBranch } = useBranch();
  const { loginCredintials } = useContext(ContextAPI);
  const location = useLocation();
  const history = useHistory();
  const url = location.pathname;
  const spareId = url.substring(url.lastIndexOf("/") + 1);
  // ----------------------

  const [allVehicles, setAllVehicles] = useState([]);
  const [popConfirmVisible, setPopConfirmVisible] = useState(false);
  const [vehicleToLink, setVehicleToLink] = useState(null);
  // const [isVehicleAlreadyAssociated, setIsVehicleAlreadyAssociated] = useState(false);


  const [partSearch, setPartSearch] = useState(false);
  const [selectedPart, setSelectedPart] = useState("");
  const [contact, setContact] = useState();
  const [tax, setTax] = useState("Tax Exclusive");
  const [quantity, setquantity] = useState();
  const [unitRate, setUnitRate] = useState();
  const [totalInvoice, setTotalInvoice] = useState();
  const [SGSTAmount, setSGSTAmount] = useState();
  const [CGSTAmount, setCGSTAmount] = useState();
  const [IGSTAmount, setIGSTAmount] = useState();
  const [search, setSearch] = useState("");
  const [deletePartData, setDeletePartData] = useState([]);
  const [partsData, setPartsData] = useState([]);
  const [page, setPage] = useState(1);
  const [associatedVehicle, setAssociatedVehicle] = useState(null);
  const [selectedVehicleValue, setSelectedVehicleValue] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState({});
  const [orderType, setOrderType] = useState(null);
  const [jobOrders, setJobOrders] = useState([]);
  const [jobCardId, setJobCardId] = useState(null);
  const [spareInventory, setSpareInventory] = useState();
  const partsRef = {};

  const [searchValue, setSearchValue] = useState('');
  const [filteredVehicles, setFilteredVehicles] = useState([]);

  // New states
  const [itemList, setItemList] = useState([partItemData]);
  const [number, setNumber] = useState("");
  const [name, setName] = useState("");
  const [orderNo, setOrderNo] = useState(null);
  const [chassisNo, setChassisNo] = useState("");
  const [registerNo, setRegisterNo] = useState("");
  const [orderDate, setOrderDate] = useState(moment(Date.now()));
  const [customerId, setCustomerId] = useState(null);
  const [discountType, setDiscountType] = useState("At Transaction Level");
  const [discountLevel, setDiscountLevel] = useState();
  const [discountAmount, setDiscountAmount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [advance, setAdvance] = useState(0);
  const [balance, setBalance] = useState(0);
  const [vehicles, setVehicle] = useState([]);
  const [colors, setColors] = useState([]);
  const [selectedColor, setSelectedColor] = useState(null);
  const [colorModal, setColorModal] = useState(false);
  const [editable, setEditable] = useState(
    location.state?.editable === true ? true : false
  );
  const modifyAccess = loginCredintials?.roleAccess?.some(
    (each) => each.subModule === "customer_spare_order" && each.access?.update
  ) ?? false;
  const [selectItemObj, setSelectItemObj] = useState({});
  const [branch, setBranch] = useState({ id: "", name: "" });
  const [vehicleData, setVehicleData] = useState(null);

  const [customer, setCustomer] = useState([]);
  const [searchSupply, setSearchSupply] = useState();
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [cusId, setCusId] = useState("");
  const [newCustomer, setNewCustomer] = useState(null);
  const [custField, setCustField] = useState();

  const [vehicleModalOpen, setVehicleModalOpen] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [showImportButton, setShowImportButton] = useState(false);
  const [existingSpareId, setExistingSpareId] = useState(null);

  const orderTypes = [
    { label: "Counter Sale", value: "COUNTER_SALE" },
    { label: "Job Card", value: "JOB_CARD" },
  ];

  const skipClearRef = useRef(false);

  // ---------------------
  const fetchJobData = async () => {
    if (location.state?.jobCard) {
      const jobDetails = location.state.jobCard;
      try {
        // First set the basic job details
        setEditable(jobDetails.editable ?? false);
        setOrderType(jobDetails.orderType);

        // Fetch jobs using the specific job number
        const jobsResponse = await getJobNo(jobDetails.jobNo);
        const jobs = jobsResponse?.data?.jobOrder || [];

        // handleJobChange relies on finding the job in the passed array or state
        handleJobChange(jobDetails.jobId, jobs);

      } catch (error) {
        console.error("Error handling job card data:", error);
      }
    }
  };

  const getSpareInventory = () => {
    platformApi.post("/api/sparesInventory/getAllByBranch").then((res) => {
      const spareObject = {};
      const spares = res.data && res.data.response && res.data.response.data;
      if (Array.isArray(spares)) {
        for (const spare of spares) {
          const partNumber = spare.partNo?.partNumber;
          if (partNumber) {
            spareObject[partNumber] = spare;
          }
        }
      }
      setSpareInventory(spareObject);
    }).catch((err) => {
      console.error("Error in getSpareInventory:", err);
      setSpareInventory({});
    });
  }


  const handleSearch = (value) => {
    setSearchValue(value);

    if (!associatedVehicle || associatedVehicle.length === 0) {
      setFilteredVehicles([]);
      return;
    }

    if (!value) {
      setFilteredVehicles(associatedVehicle);
      return;
    }

    const filtered = associatedVehicle.filter(vehicle =>
      vehicle?.vehicle?.modelCode?.toLowerCase().includes(value.toLowerCase()) ||
      vehicle?.vehicle?.modelName?.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredVehicles(filtered);
  };

  // Initialize filtered vehicles when associatedVehicle changes
  useEffect(() => {
    const obj = {};
    for (const item of itemList) {
      if (item.partNumber && item.partNumber.id) {
        obj[item.partNumber.id] = true;
      }
    }
    setSelectItemObj(obj);
  }, [itemList]);

  useEffect(() => {
    if (associatedVehicle && associatedVehicle.length > 0) {
      setFilteredVehicles(associatedVehicle);
    } else {
      setFilteredVehicles([]);
    }
  }, [associatedVehicle]);

  // Determine if Add Vehicle button should be shown (only when a search term is entered and no matching vehicle exists)
  const shouldShowAddButton = Boolean(
    searchValue && searchValue.trim() !== "" && filteredVehicles.length === 0
  );

  useEffect(() => {
    fetchJobData();
  }, [location.state]);

  useEffect(() => {
    if (branch?.id && orderType == "JOB_CARD" && spareId == ":id") {
      if (skipClearRef.current) {
        skipClearRef.current = false;
        // Don't clear if we just set the branch from a job card load
        if (branch?.id) getJobNo("");
        return;
      }
      getJobNo("")

      // Clear Job Number
      setJobCardId(null);
      setFieldsValue({ jobNo: undefined });

      // Clear Customer Name
      setCustomerId(null);
      setName("");
      setNumber("");
      setCustField("");
      setFieldsValue({ customer: undefined });

      // Clear Vehicle
      setSelectedVehicle({});
      setSelectedVehicleValue("");
      setRegisterNo("");
      setChassisNo("");
      setFieldsValue({ vehicle: undefined });

      // Clear Select Color
      setSelectedColor(null);
      setExistingSpareId(null);
    }
  }, [branch, orderType])

  useEffect(() => {
    getSpareInventory();
    if (spareId !== ":id") {
      platformApi
        .get("/api/customerSpareOrderRouter/" + spareId)
        .then((res) => {
          let { data } = res;
          if (data?.response?.code == 200) {
            let val = data?.response?.data;
            setOrderNo(val.orderNumber);
            setCustomerId(val?.partyName?.id || null);
            setVehicleData(val?.soldVehicle?.vehicle?.id || "");

            setRegisterNo(val?.soldVehicle?.registerNo || "");
            setChassisNo(val?.soldVehicle?.chassisNo);

            // Fix: Set the customer data properly
            if (val.partyName) {
              setName(val.partyName.name || "");
              setNumber(val.partyName.contacts?.[0]?.phone || "");
              setCustField(
                formatCustomerLabel(val.partyName.name, val.partyName.contacts)
              );

              setCustomerId(val.partyName.id);

              // Also update the customer state with this customer
              setCustomer([val.partyName]);
            } else {
              setName("");
              setNumber("");
              setCustField("");
              setCustomerId(null);
            }

            setAdvance(val.Advance);
            setGrandTotal(val.GrandTotal);
            setBalance(val.Balance);
            setBranch({ id: val.branch?.id || "", name: val.branch?.name || "" });
            setDiscountType(val.discountType);
            setDiscountLevel(val.discountlevel);
            setDiscountAmount(val.discountAmount);
            setOrderType(val.orderType);
            setJobCardId(val.jobCard?.id);
            setItemList(val.customerSpareOrderItem || val.orderItem || []);
            if (val.orderType === "JOB_CARD" && val.jobCard?.id) {
              setShowImportButton(true);
            } else {
              setShowImportButton(false);
            }

            if (val.soldVehicle?.vehicle) {
              setSelectedVehicleValue(
                val?.soldVehicle?.vehicle?.modelCode + " - " + val.soldVehicle?.vehicle.modelName
              );
              setFieldsValue({
                vehicle:
                  val?.soldVehicle?.vehicle?.modelCode + " - " + val.soldVehicle?.vehicle.modelName,
                jobNo: val.jobCard?.jobNo,
                // Fix: Also set the customer field in form values
                ...(val.partyName ? { customer: formatCustomerLabel(val.partyName.name, val.partyName.contacts) } : {})
              });
              setSelectedColor({
                id: val?.soldVehicle?.color?.id,
                url: val?.soldVehicle?.color?.url,
                color: val?.soldVehicle?.color?.color,
                code: val?.soldVehicle?.color?.code,
              });

              // Fetch associated vehicles if needed
              if (val.orderType === "COUNTER_SALE" && val.partyName?.id) {
                platformApi
                  .post("/api/vehicle/customerVehicle", {
                    customer: val.partyName.id,
                  })
                  .then((res) => {
                    setAssociatedVehicle(res.data.response.data);
                  });
              }
            } else {
              // Set customer field even if no vehicle
              if (val.partyName) {
                setFieldsValue({
                  customer: formatCustomerLabel(val.partyName.name, val.partyName.contacts)
                });
              }
            }
          } else {
            message.error("Something went wrong!!", 1);
          }
        })
        .catch((err) => {
          message.error("Something went wrong!!", 2);
        });
    }
  }, []);

  useEffect(() => {
    if (spareId !== ":id") return; // edit: keep loaded branch
    if (location.state?.jobCard) return; // job card sets its own branch
    if (!nearestBranch?.id) return;
    setBranch({ id: nearestBranch.id, name: nearestBranch.name || "" });
  }, [nearestBranch, spareId]);

  useEffect(() => {
    if (spareId === ":id" && branch.id) {
      platformApi.post("/api/idGenerate/customerSpareOrder", { branch: branch.id }).then((res) => {
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          setOrderNo(response.data);
        }
      });
    }
  }, [branch.id, spareId]);

  useEffect(() => {
    platformApi.get(`/api/vehicleMaster`).then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setVehicle(response.data);
        }
      }
    });
    setFieldsValue({ category: "" });
  }, []);

  const getJobNo = (value) => {
    const branchIds = (branch?.id ? [branch?.id] : (selectBranch || []).map((item) => item?.id)).filter(Boolean);
    const payload = {
      page: 1,
      size: 50,
      searchString: value,
      branch: branchIds,
      status: "ALL",
      filter: { mechanic: [] }
    };
    return platformApi.post("/api/jobOrder/get", payload)
      .then((res) => {
        const resp = res.data && res.data.response;
        if (resp && resp.data) {
          setJobOrders(resp.data.jobOrder || []);
        } else {
          setJobOrders([]);
        }
        return resp || [];
      })
      .catch((err) => {
        console.error("Error in getJobNo:", err);
        setJobOrders([]);
        return [];
      });
  };

  // Also update the handleOrderTypeChange to clear vehicles when switching types
  const handleOrderTypeChange = (value) => {
    setRegisterNo("");
    setOrderType(value);
    setJobCardId(null);
    setSelectedVehicle({});
    setSelectedVehicleValue("");
    setSelectedColor(null);
    setChassisNo("");
    setCustField("");
    setCustomerId(null);
    setName("");
    setNumber("");
    setAssociatedVehicle(null);
    setAllVehicles([]);
    setFilteredVehicles([]);
    setExistingSpareId(null);

    setFieldsValue({
      vehicle: undefined,
      jobNo: undefined,
      customer: undefined,
      vehicleAssociated: undefined,
    });

    if (value !== "JOB_CARD") {
      setShowImportButton(false);
    }
  };
  const handleJobChange = (id, job) => {

    if (!id) {
      setShowImportButton(false);
      setExistingSpareId(null);
      return;
    }

    let jobList = [];
    if (job && Array.isArray(job) && job.length > 0) {
      jobList = job;
    } else if (jobOrders.length > 0) {
      jobList = jobOrders;
    }

    // Find the job in current state
    const selectedJob = jobList.find((job) => job.id === id);

    if (!selectedJob) {
      console.warn("No job found with id:", id);
      return;
    }

    setJobCardId(id);
    setShowImportButton(true);

    // Set flag to skip clearing in the useEffect dependent on branch change
    skipClearRef.current = true;
    setBranch(selectedJob.branch)

    if (selectedJob.vehicle) {
      setSelectedVehicle(selectedJob.vehicle);
      const modelCode = selectedJob.vehicle?.vehicle?.modelCode || "";
      const modelName = selectedJob.vehicle?.vehicle?.modelName || "";
      const vehicleVal = modelCode || modelName ? `${modelCode} - ${modelName}` : "";
      setSelectedVehicleValue(vehicleVal);

      setSelectedColor({
        id: selectedJob.vehicle?.color?.id,
        url: selectedJob.vehicle?.color?.url,
        color: selectedJob.vehicle?.color?.color,
        code: selectedJob.vehicle?.color?.code,
      });

      setFieldsValue({
        vehicle: vehicleVal,
        jobNo: selectedJob.jobNo,
      });

      setChassisNo(selectedJob.vehicle.chassisNo);
      setRegisterNo(selectedJob.vehicle.registerNo || "");
      setCustField(
        formatCustomerLabel(selectedJob.customer.name, selectedJob.customer.contacts)
      );
      setCustomerId(selectedJob.customer.id);

      // Check for existing spare order
      platformApi.get(`/api/jobOrder/checkSpareOrder/${id}`).then((res) => {
        if (res.data.response.code === 200) {
          const val = res.data.response.data;
          setExistingSpareId(val.id);
          setOrderNo(val.orderNumber);
          setAdvance(val.Advance);
          setGrandTotal(val.GrandTotal);
          setBalance(val.Balance);
          setDiscountType(val.discountType);
          setDiscountLevel(val.discountlevel);
          setDiscountAmount(val.discountAmount);
          setItemList(val.customerSpareOrderItem || val.orderItem || []);
        } else {
          setExistingSpareId(null);
        }
      });
    }
  };

  const handleModelChange = (id) => {
    vehicles.some((vehicle) => {
      if (vehicle.id === id) {
        setColors(vehicle.image);
        setFieldsValue({ category: vehicle.category });
        setSelectedColor(null);
        // setVehicleModal(vehicle.category)
        setVehicleData(vehicle.id);
      }
    });
  };

  // NEW ADD..............................

  useEffect(() => {
    if (spareId === ":id" || editable) {
      if (
        itemList &&
        itemList?.length > 0 &&
        (itemList[itemList?.length - 1].partNumber.partNumber ||
          itemList[itemList?.length - 1].quantity?.length > 0)
      ) {
        handleAdd();
        setSearch("");
      }
      const selectItem = {};
      for (const item of itemList) {
        selectItem[item.partNumber.id] = item.partNumber;
      }
      setSelectItemObj(selectItem);
      // if(discountType === "At Transaction Level") calculateTransactionTax();
      // if(discountType === "At Item Level") calculateItemTax();
    }
  }, [itemList, editable]);

  // ------------updated

  useEffect(() => {
    if (search) {
      getPartsDetailOnSearch(search);
    } else {
      getPartsDetails();
    }
  }, [search]);

  const getPartsDetails = () => {
    platformApi
      .post(`/api/partsMaster/get/`, {
        page: page,
        size: 100,
        searchString: "",
      })
      .then((res) => {
        //setSpinning(false);
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setPartsData(response.data.partsMaster);
          }
        } else {
          message.error("Unable to fetch Parts", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Parts Master : ", error);
        // setSpinning(false);
        message.error("Unable to fetch Parts", 2);
      });
  };

  const getPartsDetailOnSearch = async (search) => {
    await platformApi
      .post("/api/purchaseSpareInvoice/search", {
        search,
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setPartsData(response.data.partsMasterData);
          }
        } else {
          message.error("Unable to fetch Parts", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Parts Master : ", error);
        // setSpinning(false);
        message.error("Unable to fetch Parts", 2);
      });
  };

  useEffect(() => {
    let sgstAmt = 0;
    let cgstAmt = 0;
    let igstAmt = 0;
    const newItemList = [...itemList];
    if (unitRate == null || quantity == null) return;
    for (const index in newItemList) {
      if (newItemList[index].quantity < 1 || newItemList[index].unitRate < 1)
        continue;
      newItemList[index].grossAmount = roundOf(
        newItemList[index].quantity * newItemList[index].unitRate
      );
      newItemList[index].igstAmount = getGSTRateFromPrice({
        price: parseFloat(newItemList[index].grossAmount),
        gstPercentage: newItemList[index].igst,
      });
      const gstByTwo = parseFloat(newItemList[index].igstAmount / 2);
      newItemList[index].sgstAmount = roundOf(gstByTwo);
      newItemList[index].cgstAmount = roundOf(gstByTwo);
      sgstAmt = newItemList[index].sgstAmount;
      cgstAmt = newItemList[index].cgstAmount;
      igstAmt = newItemList[index].igstAmount;
    }
    setSGSTAmount(sgstAmt);
    setIGSTAmount(igstAmt);
    setCGSTAmount(cgstAmt);
    setItemList(newItemList);
  }, [unitRate, quantity]);

  useEffect(() => {
    if (itemList[0].quantity === "" || itemList[0].unitRate === "") return;
    if (discountType === "At Transaction Level") calculateTransactionTax();
    if (discountType === "At Item Level") calculateItemTax();
  }, [
    unitRate,
    quantity,
    tax,
    totalInvoice,
    discount,
    discountAmount,
    discountLevel,
    discountType,
    advance,
    balance,
  ]);

  useEffect(() => {
    setBalance(grandTotal - advance);
  }, [grandTotal, advance]);

  useEffect(() => {
    if (spareId !== ":id") {
      platformApi
        .get("/api/customerSpareOrderRouter/" + spareId)
        .then((res) => {
          let { data } = res;
          if (data?.response?.code == 200) {
            let val = data?.response?.data;
            setOrderNo(val.orderNumber);
            setCustomerId(val?.partyName?.id || null);
            setVehicleData(val?.soldVehicle?.vehicle?.id || "");

            setRegisterNo(val?.soldVehicle?.registerNo || "");
            setChassisNo(val?.soldVehicle?.chassisNo);

            // setOrderDate(val.orderDate);
            setAdvance(val.Advance);
            setBranch({ id: val.branch?.id || "", name: val.branch?.name || "" });
            if (val.partyName) {
              setName(val.partyName.name || "");
              setNumber(val.partyName.contacts?.[0]?.phone || "");
              setCustField(
                formatCustomerLabel(val.partyName.name, val.partyName.contacts)
              );
            } else {
              setName("");
              setNumber("");
              setCustField("");
            }
            setDiscountType(val.discountType);
            setDiscountLevel(val.discountlevel);
            setDiscountAmount(val.discountAmount);
            setOrderType(val.orderType);
            setJobCardId(val.jobCard?.id);
            // Enrich loaded items: set per-item grandTotal = grossAmount (pure, no GST).
            // This prevents NaN when calculateTransactionTax/calculateItemTax reads item.grandTotal.
            const loadedItems = (val.customerSpareOrderItem || val.orderItem || []).map(item => ({
              ...item,
              grandTotal: parseFloat(item.grossAmount) || 0,
            }));
            // Grand Total = sum of grossAmount minus discount (no GST), per user requirement
            const sumGrossLoad = loadedItems.reduce((sum, item) => sum + (parseFloat(item.grossAmount) || 0), 0);
            const loadDiscountAmt = parseFloat(val.discountAmount) || 0;
            const loadDiscountLevel = val.discountlevel;
            let computedGrandTotal = sumGrossLoad;
            if (loadDiscountAmt > 0) {
              if (loadDiscountLevel === "percent") {
                computedGrandTotal = sumGrossLoad - (sumGrossLoad * loadDiscountAmt) / 100;
              } else {
                computedGrandTotal = sumGrossLoad - loadDiscountAmt;
              }
            }
            setGrandTotal(parseFloat(computedGrandTotal.toFixed(2)));
            setItemList(loadedItems);
            if (val.soldVehicle?.vehicle) {
              setSelectedVehicleValue(
                val?.soldVehicle?.vehicle?.modelCode + " - " + val.soldVehicle?.vehicle.modelName
              );
              setFieldsValue({
                vehicle:
                  val?.soldVehicle?.vehicle?.modelCode + " - " + val.soldVehicle?.vehicle.modelName,
                jobNo: val.jobCard?.jobNo,
              });
              setSelectedColor({
                id: val?.soldVehicle?.color?.id,
                url: val?.soldVehicle?.color?.url,
                color: val?.soldVehicle?.color?.color,
                code: val?.soldVehicle?.color?.code,
              });
              if (val?.partyName?.id) {
                platformApi
                  .post("/api/vehicle/customerVehicle", {
                    customer: val?.partyName?.id,
                  })
                  .then((res) => {
                    setAssociatedVehicle(res.data.response.data);
                  });
              }
            }
          } else {
            message.error("Something went wrong!!", 1);
          }
        })
        .catch((err) => {
          message.error("Something went wrong!!", 2);
        });
    }
  }, []);

  const handlePartDetail = (event, data) => {
    const newItemList = [...itemList];
    setSelectedPart(event);
    if (event !== undefined) {
      partsData.map((part) => {
        if (part.partNumber === event) {
          for (let item of newItemList) {
            if (item.id === data.id) {
              item.partNumber = part;
              item.hsn = part.hsn || null;
              item.cgst = part.hsn ? part.hsn.cgst : 0;
              item.igst = part.hsn ? part.hsn.igst : 0;
              item.sgst = part.hsn ? part.hsn.sgst : 0;
              item.gstRate = part.hsn ? (Number(part.hsn.cgst || 0) + Number(part.hsn.sgst || 0)) : 0;
              item.unitRate = part.mrp;
              item.quantity = 1;
              setquantity(1);
              setUnitRate(part.mrp);
            }
          }
        }
      });
    }
    setItemList(newItemList);
  };

  const handleQuantity = (event, record) => {
    const raw = event.target.value;
    // Strip non-digit characters, then remove leading zeros, default to empty string
    const stripped = raw.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
    const quantity = stripped === '' ? 0 : parseInt(stripped, 10);
    setquantity(quantity);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.quantity = quantity;
        item.grossAmount = quantity * item.unitRate;
        break;
      }
    }

    let grandTotal = 0;
    for (let item of newItemList) {
      grandTotal += item.grossAmount;
    }
    setGrandTotal(grandTotal);
    setItemList(newItemList);
  };

  const handleUnitRate = (event, record) => {
    // Only allow positive numeric values and decimal point
    const value = event.target.value;
    const numericValue = value.replace(/[^0-9.]/g, '');

    // Prevent multiple decimal points and negative values
    const decimalCount = (numericValue.match(/\./g) || []).length;
    let finalValue = decimalCount > 1 ? numericValue.slice(0, numericValue.lastIndexOf('.')) : numericValue;

    // Remove negative sign if present
    finalValue = finalValue.replace(/-/g, '');

    setUnitRate(finalValue);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.unitRate = finalValue;
        item.grossAmount = item.quantity * finalValue;
        break;
      }
    }
  };

  const handleDiscount = (event, record) => {
    // Only allow positive numeric values and decimal point
    const value = event.target.value;
    const numericValue = value.replace(/[^0-9.]/g, '');

    // Prevent multiple decimal points and negative values
    const decimalCount = (numericValue.match(/\./g) || []).length;
    let finalValue = decimalCount > 1 ? numericValue.slice(0, numericValue.lastIndexOf('.')) : numericValue;

    // Remove negative sign if present
    finalValue = finalValue.replace(/-/g, '');

    setDiscount(finalValue);
    let newItemList = [...itemList];
    for (let item of newItemList) {
      if (item.id === record.id) {
        item.discount = finalValue;
        break;
      }
    }
  };

  const handleDiscountAmount = (event) => {
    // Only allow numeric values and decimal point
    const value = event.target.value;
    const numericValue = value.replace(/[^0-9.]/g, '');

    // Prevent multiple decimal points
    const decimalCount = (numericValue.match(/\./g) || []).length;
    const finalValue = decimalCount > 1 ? numericValue.slice(0, numericValue.lastIndexOf('.')) : numericValue;

    setDiscountAmount(finalValue);
  };

  const handleAdvance = (event) => {
    // Only allow positive numeric values and decimal point
    const value = event.target.value;
    const numericValue = value.replace(/[^0-9.]/g, '');

    // Prevent multiple decimal points and negative values
    const decimalCount = (numericValue.match(/\./g) || []).length;
    let finalValue = decimalCount > 1 ? numericValue.slice(0, numericValue.lastIndexOf('.')) : numericValue;

    // Remove negative sign if present
    finalValue = finalValue.replace(/-/g, '');

    setAdvance(finalValue);
  };

  const renderColumns = () => {
    const columns = [
      {
        title: "S.No",
        dataIndex: "sno",
        key: "sno",
        width: 65,
        render: (text, record, index) => (
          <Form.Item>
            <span>{index + 1}</span>
          </Form.Item>
        ),
      },
      {
        title: "Part Details",
        dataIndex: "partNumber",
        key: "partNumber",
        width: 360,
        render: (record, data, key) => (
          <Form.Item>
            <Select
              dropdownStyle={{
                overflowY: "auto",
                overflowX: "hidden",
              }}
              onChange={(event) => {
                // setPartSearch(true);
                handlePartDetail(event, data);
              }}
              onSearch={(event) => {
                setSearch(event);
                if (partsData?.length === 1) {
                  const part = partsData[0];
                  if (!(part.id in selectItemObj) || part.id === data.partNumber?.id) {
                    handlePartDetail(part.partNumber, data);
                    partsRef[key].focus();
                  }
                }
              }}
              value={
                record?.partNumber == undefined
                  ? "Part Number"
                  : `${record.partNumber} - ${record.partName}`
              }
              disabled={!editable}
              showSearch
              showAction={["click", "focus"]}
              placeholder="Part Number"
              filterOption={(input, option) =>
                option.props.children.some(
                  (child) =>
                    child.toLowerCase().indexOf(input.toLowerCase()) >= 0
                )
              }
            >
              {partsData &&
                partsData.length > 0 &&
                partsData.map((part) => {
                  if (part.id in selectItemObj && part.id !== data.partNumber?.id) return null;
                  return (
                    <Select.Option key={part.id} value={part.partNumber}>
                      {part.partNumber} - {part.partName}
                    </Select.Option>
                  );
                })}
            </Select>
          </Form.Item>
        ),
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 80,
        render: (data, record, index) => (
          <Form.Item>
            <Input
              key="quantity"
              disabled={!editable}
              type="text"
              onKeyPress={(e) => {
                // Allow digits only; block everything else (including leading zeros when value is already 0)
                if (!/[0-9]/.test(e.key)) e.preventDefault();
              }}
              onChange={(event) => {
                handleQuantity(event, record);
              }}
              ref={(el) => (partsRef[index] = el)}
              placeholder="quantity"
              value={record && record.quantity}
            />
          </Form.Item>
        ),
      },
      {
        title: "Unit rate",
        dataIndex: "unitRate",
        key: "unitRate",
        width: 100,
        render: (data, record, index) => (
          <Form.Item>
            <Input
              key="unitRate"
              disabled={!editable}
              onChange={(event) => {
                handleUnitRate(event, record);
              }}
              placeholder="Unit Rate"
              value={record && record.unitRate}
            />
          </Form.Item>
        ),
      },
      {
        title: "Discount",
        dataIndex: "discount",
        key: "discount",
        width: 80,
        render: (data, record) => (
          <Form.Item>
            <Input
              key="discount"
              onChange={(event) => {
                handleDiscount(event, record);
              }}
              disabled={!editable}
              placeholder="Discount"
              value={record && record.discount}
            />
          </Form.Item>
        ),
      },
      {
        title: "Gross Amount",
        dataIndex: "grossAmount",
        key: "grossAmount",
        width: 120,
        render: (data, record) => (
          <Form.Item>
            <Input
              key="grossAmount"
              disabled={!editable}
              placeholder="GrossAmount"
              value={record && record.grossAmount}
            />
          </Form.Item>
        ),
      },
      {
        title: "Physical Quantity",
        dataIndex: "physicalQuantity",
        key: "physicalQuantity",
        width: 90,
        render: (data, record) => {
          const partNumber = record.partNumber?.partNumber;
          const physicalQty = partNumber && spareInventory && spareInventory[partNumber]
            ? spareInventory[partNumber].phyQuantity
            : '-';

          return (
            <Form.Item>
              <Input
                key="physicalQuantity"
                disabled={true}
                placeholder="Physical Quantity"
                value={physicalQty}
              />
            </Form.Item>
          );
        },
      },
      {
        title: "Bin Location",
        dataIndex: "binLocation",
        key: "binLocation",
        width: 120,
        render: (data, record) => {
          const partNumber = record.partNumber?.partNumber;
          const binLocation = partNumber && spareInventory && spareInventory[partNumber]
            ? spareInventory[partNumber].binNum
            : '-';

          return (
            <Form.Item>
              <Input
                key="binLocation"
                disabled={true}
                placeholder="Bin Location"
                value={binLocation}
              />
            </Form.Item>
          );
        },
      },
      {
        title: "Action",
        dataIndex: "remove",
        key: "x",
        width: 80,
        render: (data, record) => (
          editable ? (
            itemList.length > 1 ? (
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => {
                  handleDelete(record.id);
                }}
              >
                <a style={{ color: "#6c7b8a" }}>Delete</a>
              </Popconfirm>
            ) : (
              <a style={{ color: "#ccc", cursor: "not-allowed" }}>Delete</a>
            )
          ) : null
        ),
      },
    ];

    return columns.filter((col) =>
      discountType === "At Transaction Level"
        ? col.dataIndex !== "discount"
        : col
    );
  };

  const handleAdd = () => {
    let newArr = [...itemList, partItemData];
    setItemList(newArr);
  };

  const handleDelete = (selectedId) => {
    if (itemList.length === 1) {
      return;
    }
    const deleteSource = itemList.filter((item) => item.id == selectedId);
    const updatedDataSource = itemList.filter((item) => item.id !== selectedId);
    // Grand Total = pure sum of grossAmount (no GST), use grossAmount as fallback for DB-loaded items
    const grandTotal = roundOf(
      updatedDataSource.reduce((sum, item) => sum + (parseFloat(item.grossAmount) || parseFloat(item.grandTotal) || 0), 0)
    );
    setGrandTotal(grandTotal);
    setTotalInvoice(grandTotal);
    form.setFieldsValue({
      totalInvoice: grandTotal,
    });

    for (let i = 0; i < deleteSource.length; i++) {
      if (deleteSource[i].partNumber.number || deleteSource[i].partNumber.hsn) {
        deletePartData.push(deleteSource[i].partNumber.id);
      }
    }
    setDeletePartData(deletePartData);
    setItemList(updatedDataSource);
  };

  const calculateTransactionTax = () => {
    if (discountType !== "At Transaction Level") return;
    const newItemList = [...itemList];
    let grandTotal = 0;
    let totalGstAmount = 0;
    let sgstAmt = 0;
    let cgstAmt = 0;
    let igstAmt = 0;
    if (tax === "Tax Inclusive") {
      for (const index in newItemList) {
        if (newItemList[index].unitRate && newItemList[index].quantity) {
          // let total = parseFloat(newItemList[index].rate);
          let gstRateValue = newItemList[index].gstRate / 100 + parseInt(1);
          // taxInclusive = (parseFloat(total) - parseFloat(((total) / gstRateValue))).toFixed(2);
          const gstAmount = getGSTRateFromPrice({
            price: parseFloat(newItemList[index].grossAmount),
            gstPercentage: newItemList[index].igst,
          });
          newItemList[index].igstAmount = gstAmount;
          totalGstAmount += parseFloat(gstAmount);
          const gstByTwo = roundOf(newItemList[index].igstAmount / 2);
          newItemList[index].sgstAmount = gstByTwo;
          newItemList[index].cgstAmount = gstByTwo;
          newItemList[index].grandTotal = roundOf(
            roundOf(newItemList[index].unitRate) *
            roundOf(newItemList[index].quantity)
          );
          sgstAmt = newItemList[index].sgstAmount;
          cgstAmt = newItemList[index].cgstAmount;
          igstAmt = newItemList[index].igstAmount;
          setSGSTAmount(sgstAmt);
          setIGSTAmount(igstAmt);
          setCGSTAmount(cgstAmt);

          // newItemList[index].grandTotal = total;
          grandTotal = roundOf(
            parseFloat(grandTotal) + parseFloat(newItemList[index].grandTotal)
          );
        }
      }
      if (discountAmount > 0 && !isNaN(discountAmount)) {
        if (discountLevel === "percent") {
          const totalPriceWithoutGST =
            parseFloat(grandTotal) - parseFloat(totalGstAmount);
          const discountPrice =
            (totalPriceWithoutGST * parseFloat(discountAmount)) / 100;
          grandTotal = totalPriceWithoutGST - discountPrice + totalGstAmount;
          setTotalDiscount(roundOf(discountPrice));
        } else {
          grandTotal = parseFloat(grandTotal) - parseFloat(discountAmount);
        }
      }
      setGrandTotal(roundOf(grandTotal));
      setTotalInvoice(roundOf(grandTotal));
      form.setFieldsValue({
        totalInvoice: roundOf(grandTotal),
      });
    }
    if (tax === "Tax Exclusive") {
      for (const index in newItemList) {
        if (
          newItemList[index].grossAmount > 0 &&
          newItemList[index].gstRate > 0
        ) {
          let total = roundOf(newItemList[index].grossAmount);
          let gstRateValue = newItemList[index].gstRate / 100 + parseInt(1);
          // taxExlusive = (total * (newItemList[index].gstRate / 100)).toFixed(2);
          newItemList[index].igstAmount = calculateGSTAmount({
            price: roundOf(newItemList[index].grossAmount),
            gstPercentage: newItemList[index].igst,
          });
          const gstByTwo = roundOf(newItemList[index].igstAmount / 2);
          newItemList[index].sgstAmount = gstByTwo;
          newItemList[index].cgstAmount = gstByTwo;
          sgstAmt = newItemList[index].sgstAmount;
          cgstAmt = newItemList[index].cgstAmount;
          igstAmt = newItemList[index].igstAmount;
          if (totalDiscount > 0 && !isNaN(totalDiscount)) {
            total =
              discountLevel === "percent"
                ? total - total * (parseFloat(discountAmount) / 100)
                : total - parseFloat(discountAmount);
          }
          total = total + parseFloat(newItemList[index].igstAmount);
          setSGSTAmount(sgstAmt);
          setIGSTAmount(igstAmt);
          setCGSTAmount(cgstAmt);
          newItemList[index].grandTotal = total;
        }
        grandTotal = roundOf(
          parseFloat(grandTotal) + parseFloat(newItemList[index].grandTotal || newItemList[index].grossAmount || 0)
        );
      }
      // Grand Total = sum of grossAmount minus discount (no GST)
      const sumGross1 = roundOf(
        newItemList.reduce((sum, item) => sum + (parseFloat(item.grossAmount) || 0), 0)
      );
      let pureGrandTotal = sumGross1;
      if (discountAmount > 0 && !isNaN(discountAmount)) {
        if (discountLevel === "percent") {
          pureGrandTotal = roundOf(sumGross1 - (sumGross1 * parseFloat(discountAmount)) / 100);
        } else {
          pureGrandTotal = roundOf(sumGross1 - parseFloat(discountAmount));
        }
      }
      setGrandTotal(pureGrandTotal);
      setTotalInvoice(pureGrandTotal);
      form.setFieldsValue({
        totalInvoice: pureGrandTotal,
      });
    }
    setItemList(newItemList);
  };

  const calculateItemTax = () => {
    if (discountType !== "At Item Level") return;
    let taxExlusive = 0;
    let taxInclusive = 0;
    let newItemList = [...itemList];
    let grandTotal = 0;
    let totalGstAmount = 0;
    let sgstAmt = 0;
    let cgstAmt = 0;
    let igstAmt = 0;
    if (tax === "Tax Inclusive") {
      for (const index in newItemList) {
        if (
          newItemList[index].grossAmount > 0 &&
          newItemList[index].gstRate > 0
        ) {
          let total = newItemList[index].grossAmount;
          let gstRateValue = newItemList[index].gstRate / 100 + parseInt(1);
          // taxInclusive = (parseFloat(total) - parseFloat(((total) / gstRateValue))).toFixed(2);
          newItemList[index].igstAmount = getGSTRateFromPrice({
            price: parseFloat(newItemList[index].grossAmount),
            gstPercentage: newItemList[index].igst,
          });
          const gstByTwo = roundOf(newItemList[index].igstAmount / 2);
          newItemList[index].sgstAmount = gstByTwo;
          newItemList[index].cgstAmount = gstByTwo;
          sgstAmt = newItemList[index].sgstAmount;
          cgstAmt = newItemList[index].cgstAmount;
          igstAmt = newItemList[index].igstAmount;
          if (
            newItemList[index].discount > 0 &&
            !isNaN(newItemList[index].discount)
          ) {
            if (discountLevel === "percent") {
              const priceWithoutGST =
                parseFloat(total) - parseFloat(newItemList[index].igstAmount);
              const discountPrice =
                (priceWithoutGST * parseFloat(newItemList[index].discount)) /
                100;
              total = parseFloat(total) - discountPrice;
            } else {
              total = total - parseFloat(newItemList[index].discount);
            }
          }
          setSGSTAmount(sgstAmt);
          setIGSTAmount(igstAmt);
          setCGSTAmount(cgstAmt);
          newItemList[index].grandTotal = parseFloat(total);
        }
        grandTotal = roundOf(
          parseFloat(grandTotal) + parseFloat(newItemList[index].grandTotal || newItemList[index].grossAmount || 0)
        );
      }
      // Grand Total = sum of grossAmount minus discount (no GST)
      const sumGross2 = roundOf(
        newItemList.reduce((sum, item) => sum + (parseFloat(item.grossAmount) || 0), 0)
      );
      let pureGrandTotal = sumGross2;
      if (discountType === "At Item Level") {
        let totalItemDiscount = 0;
        for (const item of newItemList) {
          const itemDisc = parseFloat(item.discount) || 0;
          if (itemDisc > 0) {
            if (discountLevel === "percent") {
              const priceWithoutGST = (parseFloat(item.grossAmount) || 0) - (parseFloat(item.igstAmount) || 0);
              totalItemDiscount += (priceWithoutGST * itemDisc) / 100;
            } else {
              totalItemDiscount += itemDisc;
            }
          }
        }
        pureGrandTotal = roundOf(sumGross2 - totalItemDiscount);
        setTotalDiscount(roundOf(totalItemDiscount));
      } else {
        if (discountAmount > 0 && !isNaN(discountAmount)) {
          if (discountLevel === "percent") {
            pureGrandTotal = roundOf(sumGross2 - (sumGross2 * parseFloat(discountAmount)) / 100);
          } else {
            pureGrandTotal = roundOf(sumGross2 - parseFloat(discountAmount));
          }
        }
      }
      setGrandTotal(pureGrandTotal);
      setTotalInvoice(pureGrandTotal);
      form.setFieldsValue({
        totalInvoice: pureGrandTotal,
      });
    }
    if (tax === "Tax Exclusive") {
      for (const index in newItemList) {
        if (
          newItemList[index].grossAmount > 0 &&
          newItemList[index].gstRate > 0
        ) {
          let total = parseFloat(newItemList[index].grossAmount);
          let gstRateValue = newItemList[index].gstRate / 100 + parseInt(1);
          // taxExlusive = (total * (newItemList[index].gstRate / 100)).toFixed(2);
          newItemList[index].igstAmount = calculateGSTAmount({
            price: parseFloat(newItemList[index].grossAmount),
            gstPercentage: newItemList[index].igst,
          });
          const gstByTwo = roundOf(newItemList[index].igstAmount / 2);
          newItemList[index].sgstAmount = gstByTwo;
          newItemList[index].cgstAmount = gstByTwo;
          sgstAmt = newItemList[index].sgstAmount;
          cgstAmt = newItemList[index].cgstAmount;
          igstAmt = newItemList[index].igstAmount;
          if (
            newItemList[index].discount > 0 &&
            !isNaN(newItemList[index].discount)
          ) {
            total =
              discountLevel === "percent"
                ? total -
                total * (parseFloat(newItemList[index].discount) / 100)
                : total - parseFloat(newItemList[index].discount);

            // total = total + parseFloat((newItemList[index].gstRate / 100) * newItemList[index].rate)
          }
          total = total + parseFloat(newItemList[index].igstAmount);
          setSGSTAmount(sgstAmt);
          setIGSTAmount(igstAmt);
          setCGSTAmount(cgstAmt);
          newItemList[index].grandTotal = total;
        }
        grandTotal = roundOf(
          parseFloat(grandTotal) + parseFloat(newItemList[index].grandTotal || newItemList[index].grossAmount || 0)
        );
      }
      // Grand Total = sum of grossAmount minus discount (no GST)
      const sumGross3 = roundOf(
        newItemList.reduce((sum, item) => sum + (parseFloat(item.grossAmount) || 0), 0)
      );
      let pureGrandTotal = sumGross3;
      if (discountType === "At Item Level") {
        let totalItemDiscount = 0;
        for (const item of newItemList) {
          const itemDisc = parseFloat(item.discount) || 0;
          if (itemDisc > 0) {
            if (discountLevel === "percent") {
              totalItemDiscount += ((parseFloat(item.grossAmount) || 0) * itemDisc) / 100;
            } else {
              totalItemDiscount += itemDisc;
            }
          }
        }
        pureGrandTotal = roundOf(sumGross3 - totalItemDiscount);
        setTotalDiscount(roundOf(totalItemDiscount));
      } else {
        if (discountAmount > 0 && !isNaN(discountAmount)) {
          if (discountLevel === "percent") {
            pureGrandTotal = roundOf(sumGross3 - (sumGross3 * parseFloat(discountAmount)) / 100);
          } else {
            pureGrandTotal = roundOf(sumGross3 - parseFloat(discountAmount));
          }
        }
      }
      setGrandTotal(pureGrandTotal);
      setTotalInvoice(pureGrandTotal);
      form.setFieldsValue({
        totalInvoice: pureGrandTotal,
      });
    }
    setItemList(newItemList);
  };

  const roundOf = (number) => {
    if (number == null) return number;
    const roundedNumber = parseFloat(number).toFixed(2);
    return parseFloat(roundedNumber);
  };
  const getGSTRateFromPrice = ({ price = "", gstPercentage = "" }) => {
    if (price == null || gstPercentage == null) return null;
    const gstRate =
      parseFloat(price) -
      parseFloat(price) * (100 / (100 + parseFloat(gstPercentage)));
    const netRate = price - gstRate;
    return roundOf(gstRate);
  };

  const calculateGSTAmount = ({ price = "", gstPercentage = "" }) => {
    if (price == null || gstPercentage == null) return null;
    const gstRate = (price * gstPercentage) / 100;
    const netRate = price + gstRate;
    return roundOf(gstRate);
  };

  const handleSubmit = () => {
    if (!branch || !branch.id) {
      message.error("Please select a Branch");
      return;
    }

    if (!orderType) {
      message.error("Please select an Order Type");
      return;
    }

    if (!customerId) {
      message.error("Please select a Customer Name");
      return;
    }

    if (orderType === "JOB_CARD" && !jobCardId) {
      message.error("Please select a Job Number");
      return;
    }

    let newItemList = [...itemList];

    // Filter out the last row if it's the blank template row
    const lastItem = newItemList[newItemList.length - 1];
    const isLastItemTemplate = !lastItem || !lastItem.partNumber || lastItem.partNumber === "Part Number";
    if (isLastItemTemplate) {
      newItemList.splice(newItemList.length - 1, 1);
    }

    // Validate that we have at least one valid part details row with a quantity
    const validList = newItemList.filter((item) => {
      if (!item || !item.partNumber || item.partNumber === "Part Number") return false;
      const hasPartNumber = typeof item.partNumber === "object" ? (!!item.partNumber.partNumber || !!item.partNumber.code) : !!item.partNumber;
      return hasPartNumber && parseFloat(item.quantity) > 0;
    });

    if (validList.length === 0) {
      message.error("Please add at least one valid part details before saving.");
      return;
    }

    newItemList = validList;
    let vehicleId = selectedVehicle?.id;
    let vehicleData = selectedVehicle?.vehicle?.id;

    const data = {
      vehicleId,
      orderNo,
      orderDate,
      customerId,
      discountType,
      discountLevel,
      discountAmount,
      grandTotal,
      advance,
      balance,
      selectedColor,
      branch,
      newItemList,
      vehicleData,
      orderType,
      // Only include job card data if order type is JOB_CARD
      ...(orderType === "JOB_CARD" && { jobCardId }),
    };

    if (spareId === ":id" && !existingSpareId) {
      platformApi
        .post("/api/customerSpareOrderRouter/", data)
        .then((res) => {
          if (res.data.response.code === 200) {
            const toastMsgs = res.data.response.data && res.data.response.data.toastMessages;
            if (toastMsgs && toastMsgs.length > 0) {
              toastMsgs.forEach((msg) => {
                message.info(msg, 6);
              });
            } else {
              message.success("Customer Spare Order Created Successfully");
            }
            return history.push("/autoadmin/customerspare");
          }
          message.error("Unable to create Customer Spare Order");
        })
        .catch((err) => {
          message.error("Unable to create Customer Spare Order");
        });
    } else {
      const idToUpdate = spareId !== ":id" ? spareId : existingSpareId;
      platformApi
        .put(`/api/customerSpareOrderRouter/${idToUpdate}`, data)
        .then((res) => {
          if (res.data.response.code === 200) {
            message.success("Customer Spare Order Updated Successfully");
            return history.push("/autoadmin/customerspare");
          }
          message.error("Unable to update Customer Spare Order");
        })
        .catch((err) => {
          message.error("Unable to update Customer Spare Order");
        });
    }
  };

  const onModify = () => {
    setEditable(true);
  };

  const handleManufacturerChange = (id) => {
    platformApi.get(`/api/vehicleMaster/man/${id}`).then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setVehicleData(response.data);
          setSelectedColor(null);
        }
      }
    });
  };

  const handleCustomerChange = async (customerID) => {
    setAssociatedVehicle(null);
    setSelectedVehicle({});
    setSelectedVehicleValue(null);
    setSelectedColor({});
    setAllVehicles([]); // Clear all vehicles
    setFieldsValue({
      vehicle: undefined,
      vehicleAssociated: undefined,
    });

    // Only fetch associated vehicles if Counter Sale
    if (orderType === "COUNTER_SALE") {
      await platformApi
        .post("/api/vehicle/customerVehicle", { customer: customerID })
        .then((res) => {
          setAssociatedVehicle(res.data.response.data);
          setFilteredVehicles(res.data.response.data);
        });
    }

    setCustomerId(customerID);
    for (let item of customer) {
      if (item.id === customerID) {
        setName(item.name);
        setNumber(item.contacts?.[0]?.phone || "");
        setCustField(formatCustomerLabel(item.name, item.contacts));
        break;
      }
    }
  };

  const searchVehicle = (searchString) => {
    if (!searchString || !searchString.trim()) {
      setAllVehicles([]);
      setFilteredVehicles(associatedVehicle || []);
      return;
    }

    const q = searchString.trim().toLowerCase();

    const matchesQuery = (v) => {
      const modelCode = (v?.vehicle?.modelCode || v?.modelCode || v?.VehicleMaster?.modelCode || "").toLowerCase();
      const modelName = (v?.vehicle?.modelName || v?.modelName || v?.VehicleMaster?.modelName || "").toLowerCase();
      const regNo = (v?.registerNo || "").toLowerCase();
      const chassisNo = (v?.chassisNo || "").toLowerCase();
      return (
        modelCode.includes(q) ||
        modelName.includes(q) ||
        regNo.includes(q) ||
        chassisNo.includes(q)
      );
    };

    const localMatches = (associatedVehicle || []).filter(matchesQuery);

    platformApi
      .post("/api/options/get/", {
        module: "vehicles",
        column: "registerNo",
        searchString: searchString,
        fields: ["id", "registerNo", "chassisNo", "vehicle", "color", "customer", "manufacturer"],
        searchColumns: ["registerNo", "chassisNo"],
        size: 100,
        page: 1,
        except: null,
      })
      .then((res) => {
        if (res.data.response) {
          const searchedVehicles = res.data.response || [];

          // Combine local matches and searched vehicles without duplicates
          const combined = [...localMatches];
          searchedVehicles.forEach((sv) => {
            if (!combined.some((v) => v.id === sv.id) && matchesQuery(sv)) {
              combined.push(sv);
            }
          });

          setAllVehicles(searchedVehicles);
          setFilteredVehicles(combined);
        } else {
          setFilteredVehicles(localMatches);
        }
      })
      .catch((error) => {
        console.error("Error searching vehicles:", error);
        setFilteredVehicles(localMatches);
      });
  };

  // Check if vehicle is already associated with customer
  const checkIfVehicleAssociated = (vehicleId) => {
    if (!associatedVehicle || associatedVehicle.length === 0) {
      return false;
    }
    return associatedVehicle.some(v => v.id === vehicleId);
  };

  // Handle vehicle selection from dropdown
  const handleVehicleSelection = async (selectedVehicle) => {
    const isAssociated = checkIfVehicleAssociated(selectedVehicle.id);

    if (isAssociated) {
      // Vehicle is already associated, proceed normally
      handleVehicleChange(selectedVehicle);
    } else {
      // Vehicle not associated, fetch full details and show confirmation
      try {
        const result = await platformApi.post("/api/vehicle/getVehicle", {
          vehicle: selectedVehicle.id,
        });

        if (result.data.code === 200 && result.data.response.code === 200) {
          setVehicleToLink(result.data.response.data);
          setPopConfirmVisible(true);
        } else {
          message.error("Failed to fetch vehicle details");
        }
      } catch (error) {
        console.error("Error fetching vehicle details:", error);
        message.error("Failed to fetch vehicle details");
      }
    }
  };

  // Handle vehicle linking confirmation
  const handleLinkVehicle = async (vehicleData, customerId) => {
    try {
      // Prepare new customer array in correct format
      let customers = Array.isArray(vehicleData?.customer)
        ? vehicleData?.customer?.map((c) =>
          c.customer && typeof c.customer === "object"
            ? { customer: c.customer?.id, id: c.id }
            : { customer: c.customer, id: c.id }
        )
        : [];

      customers.push({ customer: customerId, id: "" });

      let body = { ...vehicleData, customer: customers };

      // Ensure vehicle / manufacturer / color are id strings (match Job Order linker)
      body.vehicle = vehicleData?.vehicle?.id;
      body.manufacturer = vehicleData?.vehicle?.manufacturer?.id;
      body.color = vehicleData?.color?.id;

      // Prepare FormData as per backend requirement
      const formData = new FormData();
      formData.append("id", vehicleData?.id);
      formData.append("vehicleData", JSON.stringify(body));

      // Link the customer to the vehicle
      const result = await platformApi.put(
        `/api/vehicle/${vehicleData?.id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (
        !(
          result &&
          result.data &&
          result.data.code === 200 &&
          result.data.response &&
          result.data.response.code === 200
        )
      ) {
        const errMsg =
          result?.data?.msg ||
          result?.data?.response?.message ||
          "Failed to link vehicle to customer";
        message.error(errMsg);
        return;
      }

      message.success("Vehicle linked to customer successfully");

      // Refresh associated vehicles list
      const res = await platformApi.post("/api/vehicle/customerVehicle", {
        customer: customerId,
      });

      setAssociatedVehicle(res.data.response.data);

      // Now select this vehicle
      handleVehicleChange(vehicleData);

      setPopConfirmVisible(false);
      setVehicleToLink(null);
    } catch (error) {
      console.error("Error linking vehicle:", error);
      message.error("Failed to link vehicle to customer");
    }
  };

  // Handle confirmation cancel
  const handleLinkCancel = () => {
    setPopConfirmVisible(false);
    setVehicleToLink(null);
    setFieldsValue({
      vehicleAssociated: undefined,
    });
  };

  // Updated handleVehicleChange to set vehicle model and color
  const handleVehicleChange = (vehicle) => {
    setChassisNo(vehicle.chassisNo);
    setRegisterNo(vehicle.registerNo || "");

    setSelectedVehicle(vehicle);
    const modelCode = vehicle?.vehicle?.modelCode || "";
    const modelName = vehicle?.vehicle?.modelName || "";
    const vehicleVal = modelCode || modelName ? `${modelCode} - ${modelName}` : "";

    setSelectedVehicleValue(
      modelCode || modelName ? `${modelCode}-${modelName}` : ""
    );

    // Set the color
    setSelectedColor({
      id: vehicle?.color?.id,
      url: vehicle?.color?.url,
      color: vehicle?.color?.color,
      code: vehicle?.color?.code,
    });

    // Set vehicle model in the dropdown
    setVehicleData(vehicle?.vehicle?.id);

    setFieldsValue({
      vehicle: vehicleVal,
      vehicleAssociated: vehicleVal,
    });
  };


  useEffect(() => {
    getCustomers();
  }, []);

  const getCustomers = (search) => {
    platformApi
      .post("/api/customer/get", {
        page: 1,
        size: 10,
        searchString: search,
      })
      .then((res) => {
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            let activeCustomer = response.data.customer;
            setCustomer(activeCustomer);
          }
        } else {
          message.error("Cannot fetch Customer Data");
        }
      })
      .catch((err) => {
        console.error("Customer fetch error", err);
        message.error("Cannot fetch Customer Data");
      });
  }

  const getNumbers = (phoneNo) => {
    if (!phoneNo || !/^\d+$/.test(phoneNo.trim())) {
      setCustomer([]);
      return;
    }
    const search = {
      module: "customers",
      column: "phone",
      searchString: phoneNo,
      fields: ["contacts{phone,id,valid}"],
      searchColumns: ["contacts"],
      setValue: setCustomer,
    };

    platformApi
      .post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 100,
        page: 1,
        except: null,
      })
      .then((res) => {
        if (res.data.response) {
          search.setValue(res.data.response);
        } else {
          search.setValue([]);
        }
      });
  };

  const uploadCsv = (file) => {
    const hideLoading = message.loading("Generating...", 0);
    const formData = new FormData();
    formData.append("csv", file);

    platformApi
      .post(`api/partsMaster/upload-csv`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          const processParts = async () => {
            const existingItems = itemList.filter(
              (item) =>
                item.partNumber &&
                (item.partNumber.partNumber ||
                  item.partNumber.code ||
                  item.jobCode)
            );

            const newItemList = [...existingItems];

            for (const csvItem of response.data.data) {
              try {
                const searchResponse = await platformApi.post(
                  "/api/purchaseSpareInvoice/search",
                  {
                    search: csvItem.partNumber,
                  }
                );

                if (
                  searchResponse.data.code === 200 &&
                  searchResponse.data.response.code === 200 &&
                  searchResponse.data.response.data.partsMasterData.length > 0
                ) {
                  const existingPart =
                    searchResponse.data.response.data.partsMasterData[0];

                  const itemQty = csvItem.quantity || 1;
                  const existingIndex = newItemList.findIndex(
                    (item) =>
                      item.partNumber &&
                      item.partNumber.partNumber === existingPart.partNumber
                  );

                  if (existingIndex > -1) {
                    // Update existing row quantity and rates
                    const existingRow = { ...newItemList[existingIndex] };
                    const newQty = (parseFloat(existingRow.quantity) || 0) + itemQty;
                    existingRow.quantity = newQty;
                    existingRow.rate = existingRow.unitRate * newQty;
                    existingRow.grossAmount = existingRow.unitRate * newQty;

                    existingRow.sgstAmount = parseFloat(
                      (existingRow.sgst / 100) * existingRow.rate
                    ).toFixed(2);
                    existingRow.igstAmount = parseFloat(
                      (existingRow.igst / 100) * existingRow.rate
                    ).toFixed(2);
                    existingRow.cgstAmount = parseFloat(
                      (existingRow.cgst / 100) * existingRow.rate
                    ).toFixed(2);

                    newItemList[existingIndex] = existingRow;
                  } else {
                    // Create new row
                    const newRow = {
                      ...partItemData,
                      id: getUUID(),
                      partNumber: existingPart,
                      hsn: existingPart.hsn || null,
                      cgst: existingPart.hsn ? existingPart.hsn.cgst : 0,
                      igst: existingPart.hsn ? existingPart.hsn.igst : 0,
                      sgst: existingPart.hsn ? existingPart.hsn.sgst : 0,
                      gstRate: existingPart.hsn ? (Number(existingPart.hsn.cgst || 0) + Number(existingPart.hsn.sgst || 0)) : 0,
                      unitRate: existingPart.mrp,
                      quantity: itemQty,
                      rate: existingPart.mrp * itemQty,
                      grossAmount: existingPart.mrp * itemQty,
                    };

                    newRow.sgstAmount = parseFloat(
                      (newRow.sgst / 100) * newRow.rate
                    ).toFixed(2);
                    newRow.igstAmount = parseFloat(
                      (newRow.igst / 100) * newRow.rate
                    ).toFixed(2);
                    newRow.cgstAmount = parseFloat(
                      (newRow.cgst / 100) * newRow.rate
                    ).toFixed(2);

                    newItemList.push(newRow);
                  }
                } else {
                  message.warning(
                    `Part ${csvItem.partNumber} not found in database`
                  );
                }
              } catch (error) {
                console.error(
                  `Error searching for part ${csvItem.partNumber}:`,
                  error
                );
                message.error(`Error processing part ${csvItem.partNumber}`);
              }
            }

            // Recalculate all running totals based on the updated newItemList
            let currentTotal = 0;
            let TotalCgst = 0;
            let TotalSgst = 0;
            let TotalIgst = 0;
            let pCharge = 0;
            let labourCharge = 0;
            let consumableCharge = 0;

            for (const row of newItemList) {
              currentTotal += parseFloat(row.rate || 0);
              TotalCgst += parseFloat(row.cgstAmount || 0);
              TotalSgst += parseFloat(row.sgstAmount || 0);
              TotalIgst += parseFloat(row.igstAmount || 0);
              if (row.partNumber && row.partNumber.hsn) {
                pCharge += parseFloat(row.rate || 0);
              }
            }

            // Add empty row at the end
            newItemList.push({ ...partItemData, id: getUUID() });

            // Update form values
            form.setFieldsValue({
              totalAmount: currentTotal.toFixed(0),
              cgst: TotalCgst.toFixed(2),
              sgst: TotalSgst.toFixed(2),
              igst: TotalIgst.toFixed(2),
              partCharge: pCharge.toFixed(2),
              labourCharge: labourCharge.toFixed(2),
              consumableCharge: consumableCharge.toFixed(2),
            });

            // Update state
            setGrandTotal(currentTotal.toFixed(2));
            setItemList(newItemList);
            const uploadedPartLength = response.data.data.length;
            hideLoading();
            message.success(`${uploadedPartLength} Parts Added From CSV`);

            if (response.data.notFound && response.data.notFound.length > 0) {
              const notFoundList = response.data.notFound.join(", ");
              const warningMsg = response.data.notFound.length === 1
                ? `The part (${notFoundList}) is not available in the db`
                : `The parts (${notFoundList}) are not available in the db`;
              message.warning(warningMsg, 5);
            }
            // message.success("CSV uploaded successfully");
          };

          processParts();
        } else {
          hideLoading();
          message.error(
            "Failed to upload CSV: " +
            (response.data.message || "Unknown error")
          );
          console.error("CSV upload failed response:", response.data);
        }
      })
      .catch((error) => {
        hideLoading();
        console.error("Error uploading CSV:", error);
        message.error(
          "Failed to upload CSV: " + (error.message || "Unknown network error")
        );
      });
  };

  const addCustomerData = async (customer) => {
    await platformApi
      .post("/api/customer", customer)
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            const resData = response.data;
            getCustomers(resData.contacts[0].phone);
            setNumber(
              response && resData ? resData.contacts[0].phone : ""
            );
            setName(response && resData ? resData.name : "");
            setCustField(formatCustomerLabel(resData.name, resData.contacts));
            handleCustomerChange(resData.id)

            setCustomerId(resData.id);
            setSelectedCustomer(resData);
            message.success("Customer added successfully", 2);
          } else {
            message.error("Unable to add customer", 2);
          }
        } else if (data.code === 500 && data.err.code === 500) {
          message.error("Customer name already exists", 2);
        } else {
          message.error("Unable to add customer", 2);
        }
      })
      .catch((error) => {
        message.error("Unable to add customer", 2);
        console.error("Error on customer : ", error);
      });
  };

  const addVehicleData = async (formData, vehicle) => {
    setUploading(true);
    try {
      const response = await platformApi.post("/api/vehicle", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })

      if (response.data.code === 200) {
        handleVehicleChange(response?.data?.response?.data)

        message.success("Vehicle added successfully");
        platformApi
          .post("/api/vehicle/customerVehicle", { customer: customerId })
          .then((res) => {
            setAssociatedVehicle(res.data.response.data);
            // handleVehicleChange(res.data.response.data[0]);
          });
      } else {
        message.error("Unable to add vehicle");
      }
    } catch (error) {
      console.error("Error adding vehicle:", error);
      message.error("Unable to add vehicle");
    } finally {
      setUploading(false);
      setVehicleModalOpen(false);
      setEdit(false);
    }
  };

  const handleImportFromEstimate = async () => {
    const jobOrderNo = getFieldValue("jobNo");
    if (!jobOrderNo) {
      message.error("Please select a job order first");
      return;
    }

    try {
      const response = await platformApi.get(
        `/api/materialIssue/import-from-estimate-cso/${jobCardId}`
      );
      const { data } = response;

      if (data.code === 200 && data.data) {
        const {
          availableParts,
          totalParts,
        } = data.data;

        if (availableParts && availableParts.length > 0) {
          // Filter out parts already present in the current itemList
          const newlyApprovedParts = availableParts.filter((part) => {
            return !itemList.some(
              (existingItem) =>
                existingItem.partNumber &&
                (existingItem.partNumber.id === part.partNumber.id ||
                  existingItem.partNumber === part.partNumber.id ||
                  existingItem.partNumber.partNumber === part.partNumber.partNumber)
            );
          });

          if (newlyApprovedParts.length > 0) {
            // Convert newly approved parts to the format expected by the table
            const formattedParts = newlyApprovedParts.map((part) => ({
              id: getUUID(),
              partNumber: {
                id: part.partNumber.id,
                partNumber: part.partNumber.partNumber,
                partName: part.partNumber.partName,
                mrp: part.partNumber.mrp,
                ndp: part.partNumber.ndp,
              },
              quantity: part.quantity,
              unitRate: part.unitRate,
              grossAmount: part.quantity * part.unitRate,
              hsn: part.partNumber.hsn || {},
              cgst: part.partNumber.hsn?.cgst || 0,
              igst: part.partNumber.hsn?.igst || 0,
              sgst: part.partNumber.hsn?.sgst || 0,
              gstRate:
                (part.partNumber.hsn?.cgst || 0) +
                (part.partNumber.hsn?.sgst || 0),
              remove: "",
            }));

            // Filter out empty rows and add imported parts
            const nonEmptyRows = itemList.filter(
              (item) =>
                item.partNumber && item.partNumber.partNumber && item.quantity
            );

            const updatedItemList = [...nonEmptyRows, ...formattedParts, partItemData];

            // Update the item list with imported parts and one empty row
            setItemList(updatedItemList);

            // Update grand total based on all non-empty items
            const newTotal = updatedItemList.reduce(
              (sum, item) => sum + (parseFloat(item.grossAmount) || 0),
              0
            );
            setGrandTotal(newTotal);

            message.success(
              `Imported ${newlyApprovedParts.length} new parts from estimate`
            );
          } else {
            message.info("All approved parts from the estimate are already imported.");
          }
        } else {
          message.info("No approved parts found in the estimate");
        }
      } else if (data.code === 404) {
        message.info(
          data.message || "No approved estimate found for this job order"
        );
      } else {
        message.error(data.message || "Failed to import parts from estimate");
      }
    } catch (error) {
      console.error("Error importing from estimate:", error);
      if (error.response?.data?.code === "CONTROLLER.QUERY.ERROR") {
        message.error("Unable to fetch estimate data. Please contact support.");
      } else {
        message.error("Failed to import parts from estimate");
      }
    }
  };

  // ========================

  return (
    <div>
      {/* <Modal> */}
      <ColorSelection
        open={colorModal}
        close={() => setColorModal(false)}
        color={colors}
        selectedColor={setSelectedColor}
      />
      {/* </Modal> */}
      <Title level={4}>
        <Tooltip
          placement="topLeft"
        // title={"Back"}
        >
          <Button
            style={{ marginRight: "1rem" }}
          >
            <Link to="/autoadmin/customerspare">
              <LeftOutlined />
            </Link>
          </Button>
        </Tooltip>
        Customer Spare Order
      </Title>
      <Form className="purchase-form">
        <Row>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Order Number"
              name="orderno"
            >
              <Input value={orderNo} placeholder="" disabled={true} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Chassis Number"
              name="chassisno"
            >
              <Input value={chassisNo} placeholder="" disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Register Number"
              name="registerno"
            >
              <Input value={registerNo} placeholder="" disabled={true} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Date"
              name="orderDate"
            >
              <DatePicker disabled={true} value={orderDate} format="DD-MM-YYYY" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Branch"
              name="branch"
              required
            >
              <Select
                dropdownStyle={{
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
                value={branch.id}
                onChange={(id) => {
                  setBranch({ id, name: "" });
                }}
                showAction={["click", "focus"]}
                showSearch
                placeholder="Branch"
                filterOption={null}
                disabled={!editable}
              >
                {selectBranch.map((eachBranch) => (
                  <Select.Option key={eachBranch.id} value={eachBranch.id}>
                    {eachBranch.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Order Type"
              name="orderType"
              required
            >
              <Select
                dropdownStyle={{
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
                value={orderType}
                onChange={(value) => {
                  handleOrderTypeChange(value);
                }}
                showAction={["click", "focus"]}
                showSearch
                disabled={!editable}
                placeholder="Select Order Type"
                filterOption={null}
              >
                {orderTypes &&
                  orderTypes.map((order, index) => (
                    <Select.Option key={index} value={order.value}>
                      {order.label}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          {orderType == "JOB_CARD" && (
            <Col span={12}>
              <Form.Item
                colon={false}
                label="Job Number"
                className="purchase-form-element"
              >
                {getFieldDecorator("jobNo", {
                  rules: [{ required: false, message: "Select Job Number" }],
                })(
                  <Select
                    onChange={handleJobChange}
                    showSearch
                    showAction={["click", "focus"]}
                    placeholder="Select JobNo"
                    onSearch={(e) => {
                      getJobNo(e);
                    }}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={!editable}
                  >
                    {jobOrders.map((job) => (
                      <Select.Option key={job.id} value={job.id}>
                        {job.jobNo}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          )}
        </Row>

        {/*     */}
        <Row>

          <Col span={12}>
            <Form.Item
              className="purchase-form-element"
              label="Customer Name"
              name="customer"
              required
            >
              <Select
                dropdownStyle={{
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
                value={custField}
                onChange={(value) => {
                  handleCustomerChange(value);
                }}
                showAction={["click", "focus"]}
                showSearch
                disabled={!editable}
                placeholder="Customer"
                filterOption={null}
                onSearch={(e) => {
                  setContact(e);
                  setNumber(e);
                  if (e && !/^\d+$/.test(e.trim())) {
                    message.error("Please enter a valid Mobile No.");
                    setCustomer([]);
                    return;
                  }
                  getNumbers(e);
                }}
                notFoundContent={
                  contact && contact.trim() !== "" && /^\d+$/.test(contact.trim()) ? (
                    <Button
                      type="primary"
                      style={{
                        justifyContent: "center",
                        width: "100%",
                      }}
                      onClick={() => {
                        setNumber(contact || getFieldValue("customer") || "");
                        setModalOpen(true);
                      }}
                    >
                      Add Customer
                    </Button>
                  ) : null
                }
              >
                {customer &&
                  customer.map((cus) => (
                    <Select.Option key={cus.id} value={cus.id}>
                      {formatCustomerLabel(cus.name, cus.contacts)}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          {/*  */}
          <Col span={12}>
            <Form.Item
              colon={false}
              label="Vehicle model"
              className="purchase-form-element vehicle-model-field"
            >
              {getFieldDecorator("vehicle", {
                rules: [{ required: false, message: "Select Model" }],
              })(
                <Select
                  className="vehicle-model-select"
                  // disabled={!editable}
                  disabled={true}
                  onChange={handleModelChange}
                  showSearch
                  showAction={["click", "focus"]}
                  placeholder="Select a Model"
                  style={{ width: "100%" }}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ minWidth: 420 }}
                  // onSelect={handleManufacturerChange}
                  filterOption={(input, option) => {
                    const children = option.props.children;
                    const text = Array.isArray(children)
                      ? children.join("")
                      : String(children || "");
                    return text.toLowerCase().includes(input.toLowerCase());
                  }}
                >
                  {vehicles.map((vehicle) => (
                    <Select.Option
                      key={vehicle.id}
                      value={vehicle.id}
                      title={formatVehicleName(vehicle)}
                    >
                      {formatVehicleName(vehicle)}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>

          {orderType === "COUNTER_SALE" && customerId && (
            <Col span={14}>
              <Form.Item
                className="purchase-form-element"
                label="Vehicles associated"
                name="vehicleAssociated"
              >
                <Popconfirm
                  title="This vehicle is not linked to this customer. Do you want to link it?"
                  visible={popConfirmVisible}
                  onConfirm={() => handleLinkVehicle(vehicleToLink, customerId)}
                  onCancel={handleLinkCancel}
                  okText="Yes, Link Vehicle"
                  cancelText="No"
                >
                  <Select
                    className="vehicle-select"
                    dropdownStyle={{
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                    value={selectedVehicleValue}
                    onChange={(value) => {
                      // value here is the full vehicle object
                      handleVehicleSelection(value);
                    }}
                    optionLabelProp="label"
                    onSearch={(searchText) => {
                      setSearchValue(searchText);
                      searchVehicle(searchText);
                    }}
                    searchValue={searchValue}
                    showAction={["click", "focus"]}
                    showSearch
                    disabled={!editable}
                    placeholder="Search by Model Code, Model Name or Register No"
                    filterOption={false}
                    notFoundContent={
                      searchValue && filteredVehicles.length === 0 ? (
                        <div
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            color: "#999",
                          }}
                        >
                          No vehicles found
                        </div>
                      ) : null
                    }
                    dropdownRender={(menu) => (
                      <div>
                        {filteredVehicles.length > 0 && menu}
                        {shouldShowAddButton && (
                          <div
                            style={{
                              padding: 8,
                              textAlign: "center",
                              borderTop:
                                filteredVehicles.length > 0
                                  ? "1px solid #f0f0f0"
                                  : "none",
                              backgroundColor: "#fafafa",
                            }}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            <Button
                              type="primary"
                              onMouseDown={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setVehicleModalOpen(true);
                              }}
                              style={{
                                pointerEvents: "auto",
                              }}
                            >
                              Add Vehicle
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  >
                    {filteredVehicles && filteredVehicles?.map((vehicle) => (
                      <Select.Option
                        key={vehicle.id}
                        value={vehicle}
                        label={`${formatVehicleName(vehicle?.vehicle)} - ${vehicle.registerNo || vehicle.chassisNo}`}
                      >
                        <div
                          style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            lineHeight: "1.4",
                          }}
                        >
                          {formatVehicleName(vehicle?.vehicle)}{" - "}
                          {vehicle.registerNo || vehicle.chassisNo}
                        </div>
                      </Select.Option>
                    ))}
                  </Select>
                </Popconfirm>
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col span={3}>
            <Item
              colon={false}
              label={
                <Text style={{ fontSize: "15px", fontWeight: "bold" }}>
                  Select Color
                </Text>
              }
            >
              {getFieldDecorator("color", {
                rules: [{ required: false, message: "Select Color" }],
              })(
                <div>
                  {selectedColor ? (
                    <div>
                      <img
                        style={{ height: "100px" }}
                        src={selectedColor.url}
                      />
                      <Tag>
                        {selectedColor.code !== undefined ? (
                          <Text>
                            {selectedColor.code + " - " + selectedColor.color}
                          </Text>
                        ) : (
                          <Text>No Color Chosen</Text>
                        )}
                      </Tag>
                    </div>
                  ) : (
                    <Tag>
                      <Text>No Color Chosen</Text>
                    </Tag>
                  )}
                </div>
              )}
            </Item>
          </Col>
          <Col span={9}>
            <Button
              disabled={!editable}
              onClick={() => setColorModal(true)}
              style={{ marginTop: "6.4vh" }}
              type="primary"
            >
              Select Color
            </Button>
          </Col>
          <div>
            <Col span={6}>
              <Form.Item
                className="form-element-type"
                label="Discount Type"
                name="dicountType"
              >
                <Select
                  showSearch
                  showAction={["click", "focus"]}
                  style={{ width: 200 }}
                  disabled={!editable}
                  placeholder="Select Discount Type"
                  onChange={(value) => setDiscountType(value)}
                  value={discountType}
                >
                  <Option value="At Transaction Level">
                    At Transaction Level
                  </Option>
                  <Option value="At Item Level">At Item Level</Option>
                </Select>
              </Form.Item>
            </Col>
          </div>
          <div>
            <Col span={6}>
              <Form.Item
                className="form-element-type"
                label="Discount"
                name="discountLevel"
              >
                <Group
                  onChange={(e) => {
                    setDiscountLevel(e.target.value);
                  }}
                  value={discountLevel}
                  disabled={!editable}
                >
                  <Radio value="percent"> % </Radio>
                  <Radio value="rupee"> Rs </Radio>
                </Group>
              </Form.Item>
            </Col>
          </div>
          <div style={{ marginLeft: "50%" }}>
            {discountType === "At Transaction Level" && (
              <Col span={6}>
                <Form.Item
                  className="form-element-type"
                  label={
                    discountLevel === "percent"
                      ? "Discount Percent"
                      : "Discount Rupee"
                  }
                  name="discountAmount"
                  onChange={(e) => handleDiscountAmount(e)}
                  rules={[{}]}
                >
                  <Input
                    disabled={!editable}
                    placeholder={
                      discountLevel === "percent"
                        ? "Discount Percent"
                        : "Discount Rupee"
                    }
                    value={
                      discountType === "At Transaction Level" &&
                        discountAmount !== 0
                        ? discountAmount
                        : discountAmount
                    }
                  />
                </Form.Item>
              </Col>
            )}
          </div>
        </Row>

        <Row
          style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}
        >
          {showImportButton && (
            <Button
              type="primary"
              onClick={handleImportFromEstimate}
              style={{ width: "160px" }}
            >
              Import from Estimate
            </Button>
          )}

          <Upload
            accept=".csv"
            showUploadList={false}
            beforeUpload={(file) => {
              uploadCsv(file);
              return false;
            }}
          >
            <Button
              disabled={!editable}
              icon={<UploadOutlined />}
              style={{ width: "160px" }}
              type="primary"
            >
              Upload CSV
            </Button>
          </Upload>
          <Button
            disabled={!editable}
            onClick={() =>
              window.open("https://www.yamaha-motor-india.com/", "_blank")
            }
            style={{ width: "160px" }}
            type="primary"
          >
            Parts catalogue
          </Button>
        </Row>
        {/* Table.. */}

        <Table
          className="parts-invoice-table"
          rowKey={(record) => {
            record.id;
          }}
          columns={renderColumns()}
          dataSource={itemList}
          tableLayout="fixed"
          pagination={false}
          style={{ marginTop: "1rem", marginBottom: "1rem" }}
        />

        {/* ---------------- */}
        <div style={{ position: "relative", left: "45rem" }}>
          <Row>
            <Col span={8}>
              <Form.Item className="purchase-form-element" label="Grand Total:">
                <Input
                  style={{ marginLeft: "1rem", width: "110%" }}
                  disabled={true}
                  placeholder=""
                  value={grandTotal}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item className="purchase-form-element" label="Advance:">
                <Input
                  style={{ marginLeft: "1rem", width: "110%" }}
                  placeholder=""
                  disabled={!editable}
                  value={advance}
                  onChange={(e) => handleAdvance(e)}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item className="purchase-form-element" label="Balance:">
                <Input
                  style={{ marginLeft: "1rem", width: "110%" }}
                  placeholder=""
                  disabled={true}
                  value={balance}
                />
              </Form.Item>
            </Col>
          </Row>
          <div style={{ position: "relative", left: "9rem" }}>
            <Button
              style={{ marginRight: "1rem" }}
              size="large"
              onClick={() => history.push("/autoadmin/customerspare")}
            >
              Cancel
            </Button>
            {!editable && modifyAccess && (
              <Button
                type="primary"
                size="large"
                onClick={() => onModify()}
              >
                Modify
              </Button>
            )}
            {editable && (
              <Button
                type="primary"
                size="large"
                // disabled={btnFlag}
                onClick={() => handleSubmit()}
              >
                Save
              </Button>
            )}
          </div>
        </div>
      </Form>

      <WrappedCustomerAddModal
        emitData={(data) => addCustomerData(data)}
        contact={contact}
        open={modalOpen}
        cusId={cusId}
        setCusId={setCusId}
        number={number}
        close={() => {
          setNumber("");
          // setSelected(null);
          setModalOpen(false);
        }}
        editable={true}
      />

      <WrappedVehicleForm
        emitData={addVehicleData}
        open={vehicleModalOpen}
        editable={editable}
        setUploading={setUploading}
        uploading={uploading}
        close={() => {
          setVehicleModalOpen(false);
          setUploading(false);
          setEdit(false);
        }}
        customer={customerId}
        vData={false}
        edit={true}
        setEdit={setEdit}
      />
    </div>
  );
};
const WrappedCustomerOrderForm = Form.create()(Index);

export default withRouter(WrappedCustomerOrderForm);
